module.exports = __webpack_public_path__ + "img/logo18.de79995c.png";